// extracted by mini-css-extract-plugin
export default {"photoContainer":"ScrollPhoto_photoContainer__XBd72","image":"ScrollPhoto_image__ky0vS","overlay":"ScrollPhoto_overlay__lpybA"};